export default {
  selectedAssignmentId: '',

  assignments: {},

  selectedCardForNewAssignment: {},

  teacherAssignmentStats: {
    inactive_count: 0,
    active_count: 0,
    total_count: 0,
  },
};



// WEBPACK FOOTER //
// ./src/app/assignments/store/state.js